import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const defaultItems = [
    { label: 'Dashboard', path: '/dashboard' },
  ];

  const breadcrumbItems = items || defaultItems;

  const handleClick = (path) => {
    if (path && path !== location?.pathname) {
      navigate(path);
    }
  };

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      {breadcrumbItems?.map((item, index) => {
        const isLast = index === breadcrumbItems?.length - 1;
        const isActive = item?.path === location?.pathname;

        return (
          <React.Fragment key={item?.path || index}>
            <div
              className={`breadcrumb-item ${isActive ? 'active' : ''}`}
              onClick={() => !isLast && handleClick(item?.path)}
              style={{ cursor: isLast ? 'default' : 'pointer' }}
            >
              {item?.icon && <Icon name={item?.icon} size={16} />}
              <span>{item?.label}</span>
            </div>
            {!isLast && (
              <Icon name="ChevronRight" size={16} className="breadcrumb-separator" />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;